import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { updateCategory } from "../../api/apiCategories";
import parseError from "../../utils/parseError";

const useUpdateCategory = () => {
    const queryClient = useQueryClient();

    const {
        mutate: editCategory,
        isPending: isUpdate,
    } = useMutation({
        mutationFn: ({ id, req }) => updateCategory(req, id),
        onSuccess: (response) => {
            toast.success(response.message);
            queryClient.invalidateQueries({ queryKey: ["categories"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to update category");
        },
    });

    return {
        editCategory,
        isUpdate,
    };
};

export default useUpdateCategory;
